// servicio para manejar plantillas de prescripción
import { ref, computed } from 'vue'
import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_BASE_URL || 'https://idamedicserver.test/api/v1'

export function usePrescriptionTemplates() {
    const isLoading = ref(false)
    const error = ref(null)
    const templateStatus = ref(null)

    // Verificar si el doctor tiene plantilla
    const checkDoctorTemplate = async (doctorId) => {
        isLoading.value = true
        error.value = null

        try {
            const response = await axios.get(`${API_BASE}/doctors/${doctorId}/check-template`)
            templateStatus.value = response.data
            return response.data
        } catch (err) {
            error.value = err.response?.data?.message || 'Error al verificar plantilla'
            console.error('Error checking template:', err)
            return null
        } finally {
            isLoading.value = false
        }
    }

    // Crear plantilla por defecto
    const createDefaultTemplate = async (doctorId) => {
        isLoading.value = true
        error.value = null

        try {
            const response = await axios.post(`${API_BASE}/doctors/${doctorId}/create-default-template`)
            templateStatus.value = response.data

            return {
                success: true,
                data: response.data,
                message: 'Plantilla creada exitosamente'
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Error al crear plantilla'
            error.value = errorMessage
            console.error('Error creating template:', err)

            return {
                success: false,
                error: errorMessage,
                details: err.response?.data
            }
        } finally {
            isLoading.value = false
        }
    }

    // Obtener estado completo de plantilla
    const getTemplateStatus = async (doctorId) => {
        isLoading.value = true
        error.value = null

        try {
            const response = await axios.get(`${API_BASE}/doctors/${doctorId}/template-status`)
            return response.data
        } catch (err) {
            error.value = err.response?.data?.message || 'Error al obtener estado'
            console.error('Error getting template status:', err)
            return null
        } finally {
            isLoading.value = false
        }
    }

    // Estado computado para saber si hay plantilla
    const hasTemplate = computed(() => {
        return templateStatus.value?.hasTemplate || false
    })

    // URL de la plantilla si existe
    const templateUrl = computed(() => {
        return templateStatus.value?.templateUrl || null
    })

    return {
        // Estado
        isLoading,
        error,
        templateStatus,
        hasTemplate,
        templateUrl,

        // Métodos
        checkDoctorTemplate,
        createDefaultTemplate,
        getTemplateStatus
    }
}